import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { observer } from 'mobx-react';
import { observable } from 'mobx';

class RenameSheetDialog extends Component {
    constructor(props) {
        super(props);
        this.store = observable({
            open: true,
            listName: props.list.name
        });
    };

    handleClickOpen = () => {
        this.store.open = true;
    }

    handleClose = () => {
        this.store.listName = this.props.list.name;
        this.store.open = false;
        this.props.onClose && this.props.onClose();
    }

    handleSave = () => {
        this.props.onChange(this.store.listName);
        this.handleClose();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.list && nextProps.list !== this.store.list) {
            this.store.listName = nextProps.list.name
        }
    }
    
    handleFocus = (event) => event.target.select();

    render() {
        return (<Dialog
            open={this.store.open}
            PaperProps={{
                className: "rename_sheet_dialog"
            }}
            onClose={this.handleClose}
            aria-labelledby="form-dialog-title">
            <DialogTitle >Rename Sheet</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    id="name"
                    value={this.store.listName}
                    onChange={(ev) => { this.store.listName = ev.target.value; }}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            this.handleSave();
                        }
                    }}
                    onFocus={this.handleFocus}
                    fullWidth
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={this.handleClose} color="primary">
                    Cancel
            </Button>
                <Button onClick={this.handleSave} color="primary">
                    Save
            </Button>
            </DialogActions>
        </Dialog>);
    }
}

export default observer(RenameSheetDialog);